import { SubscriptionPlanBox } from './SubscriptionPlanBox';

export default SubscriptionPlanBox;
